module.exports = __webpack_public_path__ + "img/icon-exclamation-black.91f57b09.svg";